/**
 * TextAreaField - 複数行テキスト入力欄 (文字数カウンタ付き)
 *
 * サイズ系は上位コンポーネントから props で注入する。
 * maxLength を指定すると右下に "入力文字数/上限文字数" を表示する。
 *
 * @param {string} value          - 入力値
 * @param {function} onChange     - 変更ハンドラ
 * @param {number} maxLength      - 入力文字数の上限
 * @param {number} rows           - 表示行数 (デフォルト2行。超過分は縦スクロール)
 * @param {string} placeholder    - プレースホルダー
 * @param {string} widthClass     - 幅クラス (例: 'w-full')
 * @param {string} sizeClass      - padding / font-size クラス
 * @param {string} borderClass    - ボーダー・フォーカスクラス
 * @param {boolean} disabled      - true のとき非活性化し、暗転表示にする（集計ロック時等）
 */
function TextAreaField({
  value,
  onChange,
  maxLength,
  rows = 2,
  placeholder = "",
  widthClass = "",
  sizeClass = "px-3 py-2 text-base",
  borderClass = "border-2 border-gray-500 rounded focus:outline-none focus:border-blue-500",
  disabled = false,
}) {
  return (
    <div className={widthClass}>
      <textarea
        value={value}
        onChange={onChange}
        maxLength={maxLength}
        rows={rows}
        placeholder={placeholder}
        disabled={disabled}
        className={`w-full resize-none overflow-y-auto ${sizeClass} ${borderClass} ${disabled ? "bg-gray-50 text-gray-500 cursor-not-allowed" : ""}`}
      />
      {maxLength != null && (
        <div className="text-right text-base text-gray-500 mt-1">
          {value.length}/{maxLength}文字
        </div>
      )}
    </div>
  );
}

export default TextAreaField;
